import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

export const onRouteUpdate = () => {
    if (typeof document === "undefined") return

    const targets = document.querySelectorAll("[data-animate]")

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.dataset.active = "true"
                }
            })
        },
        { threshold: 0.2 }
    )

    targets.forEach(el => observer.observe(el))
}

export const onClientEntry = () => {
    if (typeof document !== "undefined") {
        document.documentElement.classList.add("js")
    }
}